import { InvestorRightEnumType } from '__generated__/graphql';

interface InvestorRightReadable {
  label: string;
  color: 'gray' | 'blue' | 'green' | 'yellow' | 'red';
}

const investorRightToReadable = (right: InvestorRightEnumType): InvestorRightReadable => {
  switch (right) {
    case InvestorRightEnumType.None:
      return { label: 'None', color: 'gray' };
    case InvestorRightEnumType.TagAlongRights:
      return { label: 'Tag-along rights on founder transfers', color: 'blue' };
    case InvestorRightEnumType.AntiDilutionProtection:
      return { label: 'Anti-dilution protection', color: 'green' };
    case InvestorRightEnumType.LiquidationPreference:
      return { label: 'Liquidation preference', color: 'blue' };
    case InvestorRightEnumType.PreEmptionRights:
      return { label: 'Pre-emption rights', color: 'yellow' };
    case InvestorRightEnumType.InformationRights:
      return { label: 'Information rights', color: 'gray' };
    case InvestorRightEnumType.ExitRightsParticipation:
      return { label: 'Exit rights (right to participate in an exit)', color: 'green' };
    case InvestorRightEnumType.ExitRightsControl:
      return { label: 'Exit rights (rights to control an exit event)', color: 'red' };
    case InvestorRightEnumType.FreeTransferability:
      return { label: 'Free transferability of shares', color: 'yellow' };
    case InvestorRightEnumType.AffirmativeVoteRights:
      return { label: 'Affirmative vote rights', color: 'red' };
    case InvestorRightEnumType.BoardSeat:
      return { label: 'Board seat', color: 'red' };
    case InvestorRightEnumType.RofoRofr:
      return { label: 'ROFO/ROFR', color: 'blue' };
    default:
      return { label: 'Unknown', color: 'gray' };
  }
};

export default investorRightToReadable;
